<script setup>
import { isTpad } from '@common/utils';
const listeners = useListeners()
const props = defineProps({
  img: String,
  dark: [Boolean, Number],
  disable: [Boolean, Number],
  selected: Boolean,
})

const classMap = computed(() => ({
  'nio-circle': true,
  'nio-circle-pad': isTpad,
  'nio-dark': props.dark,
  'nio-disable': props.disable,
  'nio-selected': props.selected
}))
</script>

<template>
  <div 
    :class="classMap"
    :style="{'backgroundImage': `url(${img})`}"
    v-on="!disable && listeners"
  />
</template>

<style lang="scss" scoped>
.nio-circle {
  display: inline-flex;
  width: rem(40);
  height: rem(40);
  cursor: pointer;
  position: relative;
  background-size: 0;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.05);

  &::before,
  &::after {
    display: block;
    border-radius: inherit;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &:active::after {
    content: '';
    background-color: rgba(0, 0, 0, 0.2);
  }

  // 用伪类实现不影响原始定位关系
  &::before {
    @include transition(0.4s);
    content: '';
    margin: rem(-3);
    border: rem(3) solid transparent;
    box-shadow: 0 0 0 1.5px transparent;
    pointer-events: none;
    background-image: inherit;
    background-size: cover;
    background-clip: content-box;
  }

  // 选中
  .nio-selected &,
  &.nio-selected {
    &::before {
      margin: rem(-5);
      pointer-events: auto;
      box-shadow: 0 0 0 1.5px #000;
      z-index: 1; // 覆盖active时的after
    }

    // 深色模式下选中
    .nio-dark &,
    &.nio-dark {
      &::before {
        box-shadow: 0 0 0 1.5px #fff;
      }
    }
  }

  // 禁用
  .nio-disable &,
  &.nio-disable {
    opacity: 0.5 !important;
    pointer-events: none !important;
  }
}
.nio-circle-pad{
  width: 40px;
  height: 40px;
}
</style>
